"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var _constants = require("react-dates/constants");
var _downshift = _interopRequireDefault(require("downshift"));
var R = _interopRequireWildcard(require("ramda"));
var _Input = _interopRequireDefault(require("../../../ui/Input"));
var _Label = _interopRequireDefault(require("../../../ui/Label"));
var _DateControl = require("../../../DateControl");
var _withProps = _interopRequireDefault(require("./withProps"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var MIN_DATE = (0, _moment.default)().startOf('day');
var DEFAULT_DATES = {
  from: (0, _moment.default)().add(1, 'day'),
  to: (0, _moment.default)().add(8, 'day')
};
var isBlocked = function isBlocked(day) {
  return day.clone().isBefore((0, _moment.default)().startOf('day').add(1, 'day'), 'day');
};
var isDayInRange = function isDayInRange(day, range) {
  return R.and(range.from.isSameOrBefore(day, 'day'), range.to.isSameOrAfter(day, 'day'));
};
var DatesControl = function DatesControl(_ref) {
  var availableDates = _ref.availableDates,
    value = _ref.value,
    onChange = _ref.onChange;
  var _useState = (0, _react.useState)(_constants.START_DATE),
    _useState2 = _slicedToArray(_useState, 2),
    focus = _useState2[0],
    setFocus = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpen = _useState4[0],
    setOpen = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    shouldHighLightDatesRange = _useState6[0],
    setShouldHighlightRange = _useState6[1];
  var _useTranslation = (0, _reactI18next.useTranslation)('SEARCH_FORM'),
    t = _useTranslation.t;
  var from = value.from,
    to = value.to;
  var setDefault = (0, _react.useCallback)(function (e) {
    onChange(DEFAULT_DATES);
    setFocus(_constants.START_DATE);
    setOpen(false);
    e.stopPropagation();
  }, [onChange]);
  var isOutside = (0, _react.useCallback)(function (day) {
    return focus === _constants.END_DATE && day.isAfter(value.from.clone().add(14, 'days'), 'day');
  }, [value, focus]);
  var handleFocusChange = (0, _react.useCallback)(function (newFocus) {
    return setFocus(newFocus || _constants.START_DATE);
  }, []);
  var handleToggle = (0, _react.useCallback)(function () {
    return setOpen(!isOpen);
  }, [isOpen]);
  var handleClose = (0, _react.useCallback)(function () {
    if (from && !to) {
      onChange({
        from: from,
        to: from
      });
      setFocus(_constants.START_DATE);
    }
    setOpen(false);
  }, [from, to, onChange]);
  var handleDatesChange = (0, _react.useCallback)(function (_ref2) {
    var startDate = _ref2.startDate,
      endDate = _ref2.endDate;
    var isCompleteSelection = focus === _constants.END_DATE && endDate;
    onChange({
      from: startDate,
      to: isCompleteSelection ? endDate : null
    });
    if (isCompleteSelection) {
      setOpen(false);
    }
  }, [focus, onChange]);
  var textValue = "".concat(from ? from.format('D MMM') : '').concat(to ? " - ".concat(to.format('D MMM')) : '');
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Label.default, {
    text: t('DATE_CONTROL_LABEL')
  }), /*#__PURE__*/_react.default.createElement(_downshift.default, {
    isOpen: isOpen,
    onOuterClick: handleClose
  }, function () {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Input.default, {
      readOnly: true,
      value: textValue,
      onChange: console.log,
      onClear: setDefault,
      onClick: handleToggle
    }), isOpen && /*#__PURE__*/_react.default.createElement(_DateControl.DatesRangeControl, {
      hideKeyboardShortcutsPanel: true,
      availableDates: availableDates,
      endDate: to,
      focusedInput: focus,
      getDayProps: function getDayProps(day, modifiersSet) {
        var modifiers = _toConsumableArray(modifiersSet);
        if (shouldHighLightDatesRange && isDayInRange(day, _objectSpread({}, value, {
          to: value.from.clone().add(14, 'days')
        }))) {
          modifiers.push('hovered-span');
        }
        return {
          onMouseEnter: function onMouseEnter() {
            setShouldHighlightRange(focus === _constants.END_DATE && !isDayInRange(day, _objectSpread({}, value, {
              to: value.from.clone().add(14, 'days')
            })));
          },
          modifiers: modifiers
        };
      },
      initialVisibleMonth: function initialVisibleMonth() {
        return from.clone();
      },
      isDayBlocked: isBlocked,
      isOutsideRange: isOutside,
      minDate: MIN_DATE,
      minimumNights: 0,
      startDate: from,
      onDatesChange: handleDatesChange,
      onFocusChange: handleFocusChange
    }));
  }));
};
DatesControl.propTypes = {
  availableDates: _propTypes.default.PropTypes.arrayOf(_propTypes.default.string).isRequired,
  value: _propTypes.default.object.isRequired,
  onChange: _propTypes.default.func.isRequired
};
var enhancer = R.compose(_withProps.default, _react.memo);
var _default = exports.default = enhancer(DatesControl);